import instance from "../../utils/axios";

// ✅ Save Leadership Team Language Meta API
export const saveLeadershipLanguageMeta = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) =>
    formData.append(key, val ?? "")
  );

  const response = await instance.post(
    "/churches/languagemetas/leadershipteam/save",
    formData
  );

  return response.data;
};
